/**
 * TIA's agent states — the single source for the 7-state visual language.
 * Values (glow, label, labelColor) are FINAL per the design handoff's state table
 * (design_handoff_ticksy_panel/README.md §The 7 states) — do not tweak ad hoc.
 */

export type AgentState =
  | 'idle'
  | 'thinking'
  | 'searching'
  | 'writing'
  | 'confirm'
  | 'done'
  | 'error';

export interface AgentStateMeta {
  /** Ambient/eye glow color. */
  glow: string;
  /** One-line status label shown under the name. */
  label: string;
  /** The label's text color. */
  labelColor: string;
}

export const AGENT_STATE_META: Record<AgentState, AgentStateMeta> = {
  idle: { glow: '#b9a8f5', label: 'Ready when you are', labelColor: '#6d5e88' },
  thinking: { glow: '#b9a8f5', label: 'Thinking…', labelColor: '#7c5abb' },
  searching: {
    glow: '#a9c8ff',
    label: 'Searching the CRM…',
    labelColor: '#7c5abb',
  },
  writing: {
    glow: '#c4b0ff',
    label: 'Writing your answer…',
    labelColor: '#6b46b2',
  },
  confirm: { glow: '#ffb968', label: 'Needs your OK', labelColor: '#fd8100' },
  done: { glow: '#5fe0a5', label: 'All set', labelColor: '#0e9f6e' },
  error: {
    glow: '#ff9a9a',
    label: 'Something went wrong',
    labelColor: '#e02424',
  },
};

export const AGENT_STATES = Object.keys(AGENT_STATE_META) as AgentState[];
